module.exports = __webpack_public_path__ + "img/FavminusNew.b74ec1d5.svg";